import { Pipe, PipeTransform } from "@angular/core"

@Pipe({ name: "keys" })
export class KeysPipe implements PipeTransform {
    transform(obj: any) {
        if (obj) return Object.keys(obj)
        else return obj
    }
}
